module.exports = __webpack_public_path__ + "img/aichi.ecf20288.png";